import "../pages.scss"
import { BarriosState } from '../../context/barrios/BarriosState';
import Datatable from "./barriosTable/Datatable"

const BarriosPage = () => {
  return (
    <>
      <BarriosState>
        <Datatable />
      </BarriosState>

    </>
  )
}

export default BarriosPage